module.exports = __webpack_public_path__ + "f089ce9a74e629ada25e533cd80e613b.svg";